<template>
  <section class="settings-section section-block quick-payment-link-parameter">
    <PageTitle
      icon="chevron_left"
      :title="displayText.pageTitle"
      hideBtn
      style="padding-bottom: 24px"
      @iconClick="$router.push({ name: 'Parameters' })"
    />
    <SectionTitle
      :title="displayText.sectionTitle"
      :hideBtn="!showControl.editBtn"
      @edit="modal.edit = true"
    />
    <div>
      <BaseElForm label-position="left" label-width="250px">
        <BaseElFormItem class="settings-item">
          <template slot="label">
            <div class="flex items-center" style="gap: 8px">
              <p>{{ displayText.adminQuickPaymentUrlLabel }}</p>
            </div>
          </template>
          <span class="content">{{ displayData.adminQuickPaymentUrlValue }}</span>
        </BaseElFormItem>
      </BaseElForm>
    </div>

    <EditQuickPaymentLinkModal
      v-if="modal.edit"
      :adminQuickPaymentUrl="configData.reservation.adminQuickPaymentUrl"
      @close="modal.edit = false"
      @refresh="getConfig('reservation')"
    />
  </section>
</template>

<script>
import { defineComponent, reactive, computed, onMounted } from 'vue'
import EditQuickPaymentLinkModal from './components/EditQuickPaymentLinkModal/EditQuickPaymentLinkModal.vue'
import SectionTitle from '@/components/Title/SectionTitle'
import PageTitle from '@/components/Title/PageTitle'
import { usePermissions } from '@/use/permissions'
import { useReservation } from '@/use/useReservation'
import { get } from 'lodash-es'

export default defineComponent({
  name: 'QuickPaymentLinkSettings',
  components: {
    EditQuickPaymentLinkModal,
    SectionTitle,
    PageTitle,
  },
  setup () {
    const { checkAction } = usePermissions()
    const { configData, getConfig } = useReservation()

    // 操作資料
    const modal = reactive({
      edit: false,
    })

    // 權限判斷
    const canEdit = computed(() => checkAction('admin.appointmentConfig.update'))

    // 顯示控制
    const showControl = computed(() => ({
      editBtn: canEdit.value,
    }))

    // 顯示文字
    const displayText = computed(() => ({
      pageTitle: '快速收款連結設定',
      sectionTitle: '快速收款連結設定',
      adminQuickPaymentUrlLabel: '收款連結',
    }))

    // 顯示資料
    const displayData = computed(() => ({
      adminQuickPaymentUrlValue: get(configData.reservation, 'adminQuickPaymentUrl') || '-',
    }))

    onMounted(async () => {
      await getConfig('reservation')
    })

    return {
      configData,
      getConfig,
      modal,
      showControl,
      displayText,
      displayData,
    }
  },
})
</script>

<style lang="postcss" scoped>
.content {
    @apply text-primary-100;
}
</style>
